module.exports = __webpack_public_path__ + "media/customizations/harbourisle/back-8bf8948494b648a66109f65fdd0b74f3.jpg";